import { Component, OnInit, AfterContentInit, AfterViewChecked} from '@angular/core';
import { single, multi } from '../../../interfaces/data';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.css']
})
export class VerticalComponent implements OnInit {
  cargando = true;
  single: any[];
  multi: any[];

  view: any[] = [700, 400];

  colorScheme = {
    domain: ['#00B2FF', '#FF2906', '#0B18F5', '#C2B36C']
  };

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Sectores';
  showYAxisLabel = true;
  yAxisLabel = 'Pesos Chilenos';

  constructor() {
    Object.assign(this, { single, multi })

  }


  ngAfterViewChecked() {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    setTimeout(()=>
    this.cargando=false, 1000);
  }
  ngOnInit() {

  }

  onSelect(event) {
    console.log(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/graficos/vertical/vertical.component.ts